<div class="formly-field-wrap prerequisite-roles-wrap">
  @if (isLoading) {
    <div class="loading-state">
      <ion-spinner name="crescent"></ion-spinner>
      <span>{{ 'COMMON.LOADING' | translate }}</span>
    </div>
  } @else if (loadError) {
    <div class="error-state">
      <span>{{ 'PREREQUISITE_ROLES_FIELD.LOAD_FAILED' | translate }}</span>
      <ion-button fill="outline" size="small" (click)="retryLoad()">
        {{ 'ERRORS.RETRY' | translate }}
      </ion-button>
    </div>
  } @else if (roleOptions.length === 0) {
    <div class="empty-state">{{ 'PREREQUISITE_ROLES_FIELD.EMPTY' | translate }}</div>
  } @else {
    <div class="roles-shell">
      @for (role of roleOptions; track trackByRole($index, role)) {
        <label class="role-row" [class.readonly]="isReadonly">
          <ion-checkbox
            [checked]="isRoleSelected(role.roleId)"
            [disabled]="isReadonly"
            (ionChange)="onRoleSelectionChange(role.roleId, $event.detail.checked)">
          </ion-checkbox>
          <span class="role-desc">{{ role.roleId }}<br />{{ getRoleLabel(role) }}</span>
          <!-- <span class="role-id">{{ role.roleId }}</span>
          <span class="role-separator">:</span>
          <span class="role-label">{{ getRoleLabel(role) }}</span> -->
        </label>
      }
    </div>
  }
  <ng-template #fieldComponent></ng-template>
</div>